module.exports = __webpack_public_path__ + "img/chev-right.1029b8e8.svg";